((Drupal, $) => {
  const initNewsletter = (el) => {
    const $newsletterContainer = $(el).parents('.newsletter, .newsletter-page__top');
    if (el && $newsletterContainer) {
      const config = { attributes: true, childList: true, subtree: true };

      const callback = (mutationList) => {
        mutationList.forEach((mutation) => {
          if (mutation.type === 'childList') {
            if (mutation.target && $(mutation.target).find($('#activitystream_newsletter_signup_feedback')).length > 0) {
              $('html, body').animate({
                scrollTop: $newsletterContainer.offset().top - 80,
              }, 100);
            }
          }
        });
      };

      const observer = new MutationObserver(callback);

      observer.observe(el, config);
    }
  };

  Drupal.behaviors.mstNewsletter = {
    attach: (context) => {
      $('.newsletter__form', context).each((index, element) => initNewsletter(element));
    },
  };
})(Drupal, jQuery);
